import { cn } from '@/lib/utils';

/** 제공된 원본 아트워크와 안전 여백을 함께 사용한다. 워드마크를 글자로 재작성하지 않는다. */
export default function BrandLogo({
  className,
  compact = false,
  size = 'default',
}: {
  className?: string;
  compact?: boolean;
  size?: 'default' | 'large';
}) {
  return (
    <span
      role="img"
      aria-label="Glow Pass"
      className={cn(
        'gp-brand-logo',
        compact
          ? 'gp-brand-logo--compact'
          : size === 'large' && 'gp-brand-logo--large',
        className,
      )}
    >
      <img
        src={compact ? '/brand/logo-symbol.svg' : '/brand/logo-horizontal.svg'}
        width={compact ? 200 : 900}
        height={compact ? 200 : 198}
        alt=""
        aria-hidden="true"
      />
    </span>
  );
}
